import type { ComputedPlacement } from '@popperjs/core';
import type { ReactNode } from 'react';
import React from 'react';
import * as styles from './SelectOptionContent.module.scss';
import SVGIcon from './SVGIcon';
import Tooltip from './Tooltip';

interface SelectOptionContentProps {
  label: ReactNode;
  icon: string;
  helpText: string;
  tooltip?: string | null;
  tooltipPlacement?: ComputedPlacement;
}

const SelectOptionContent = ({
  label,
  icon,
  helpText,
  tooltip = null,
  tooltipPlacement = 'top',
}: SelectOptionContentProps) => {
  const inner = (
    <div className={styles.option}>
      <div className={styles.icon}>
        <SVGIcon inline>{icon}</SVGIcon>
      </div>
      <div>
        <strong>{label}</strong>
        <br />
        {helpText}
      </div>
    </div>
  );

  return tooltip ? (
    <Tooltip placement={tooltipPlacement} content={tooltip} display="block">
      {inner}
    </Tooltip>
  ) : (
    inner
  );
};

export default SelectOptionContent;
